module.exports = __webpack_public_path__ + "img/nopic-male.0a154a8c.jpg";